﻿import { ServiceResponse, ServiceOptions, ServiceRequest, serviceRequest } from "@serenity-is/corelib";

export namespace SystemAdminService {
    export const baseUrl = 'SystemAdmin';

    export declare function ResetCache(request: string, onSuccess?: (response: ServiceResponse) => void, opt?: ServiceOptions<any>): JQueryXHR;
    export declare function ResetCurrentClientHealthDashboardCache(request: ServiceRequest, onSuccess?: (response: ServiceResponse) => void, opt?: ServiceOptions<any>): JQueryXHR;

    export const Methods = {
        ResetCache: "SystemAdmin/ResetCache",
        ResetCurrentClientHealthDashboardCache: "SystemAdmin/ResetCurrentClientHealthDashboardCache"
    } as const;

    [
        'ResetCache', 
        'ResetCurrentClientHealthDashboardCache'
    ].forEach(x => {
        (<any>SystemAdminService)[x] = function (r, s, o) {
            return serviceRequest(baseUrl + '/' + x, r, s, o);
        };
    });
}